<template>
  <video id="playerBox" controls autoplay class="w-full h-full"></video>
</template>

<script>
import flvjs from 'flv.js'

export default {
  name: 'FLVPlayer',
  props: {
    flvPlayUrl: {
      type: String,
      default: '',
      required: true,
    }, // 视频播放地址
  },
  data() {
    return {
      flvPlayer: null, // 播放器实例
    }
  },
  methods: {
    /**
     * @description 初始化视频播放
     */
    initPlay() {
      console.log('flvjs.isSupported()', flvjs.isSupported())
      if (!flvjs.isSupported()) {
        this.$message.warning('当前浏览器不支持播放FLV视频')
        return
      }
      const videoElement = document.getElementById('playerBox')
      this.flvPlayer = flvjs.createPlayer({
        type: 'flv',
        url: this.flvPlayUrl,
      })
      this.flvPlayer.attachMediaElement(videoElement)
      this.flvPlayer.load() // 加载视频
      this.flvPlayer.play() // 播放视频
    },

    /**
     * @description 关闭视频流
     */
    stopPlay() {
      if (!this.flvPlayer) return
      this.flvPlayer.pause() // 视频暂停
      this.flvPlayer.unload() // 去除加载视频
      this.flvPlayer.detachMediaElement() // 将播放实例从节点中去除
      this.flvPlayer.destroy() // 销毁播放实例
      this.flvPlayer = null
    },
  },
  mounted() {
    this.initPlay()
  },
  destroyed() {
    this.stopPlay()
  },
}
</script>
